import { BadgeCheck, Home } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { PRICES } from "@/lib/data";

const Pricing = () => (
  <section id="listino" data-testid="pricing-section" className="bg-white py-28 lg:py-36">
    <div className="max-w-4xl mx-auto px-6 lg:px-10">
      <Reveal className="text-center mb-16">
        <Overline>03 — Listino Sedute</Overline>
        <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#1A2E2A] leading-[1.1]">
          Tariffe Chiare, <span className="italic text-[#489A88]">Senza Sorprese</span>
        </h2>
      </Reveal>

      <div>
        {PRICES.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.1}>
            <div
              data-testid={`pricing-row-${i}`}
              className="group flex items-baseline gap-4 py-7 border-t border-[#E2E8F0] last:border-b"
            >
              <div className="min-w-0">
                <h3 className="font-['Outfit'] text-lg sm:text-xl font-medium text-[#1A2E2A] group-hover:text-[#2D6D60] transition-colors duration-300">
                  {p.name}
                </h3>
                <p className="text-sm text-[#64748B] mt-1">{p.duration}</p>
              </div>
              <div className="flex-1 border-b border-dotted border-[#B9D9D1] translate-y-[-6px]" aria-hidden="true" />
              <span className="font-['Outfit'] text-2xl sm:text-3xl font-light text-[#1A2E2A] whitespace-nowrap">{p.price}</span>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-10 rounded-2xl bg-[#E8F5F2] px-7 py-6 flex flex-col sm:flex-row gap-5">
          <p className="flex items-start gap-3 text-sm text-[#2D6D60] flex-1">
            <BadgeCheck className="w-5 h-5 shrink-0 mt-0.5" />
            Utilizzo del kinesio taping sempre incluso nel trattamento, quando necessario.
          </p>
          <p className="flex items-start gap-3 text-sm text-[#2D6D60] flex-1">
            <Home className="w-5 h-5 shrink-0 mt-0.5" />
            Possibilità di trattamenti a domicilio.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
